import { useState } from "react";
import { RefreshCw } from "lucide-react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { useReactivateUser } from "@/hooks/useTeamManagement";

interface ReactivateUserDialogProps {
  user: {
    id: string;
    display_name: string | null;
    email: string;
  };
}

export function ReactivateUserDialog({ user }: ReactivateUserDialogProps) {
  const [open, setOpen] = useState(false);
  const reactivateUser = useReactivateUser();

  const handleReactivate = async () => {
    await reactivateUser.mutateAsync(user.id);
    setOpen(false);
  };

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger asChild>
        <Button variant="ghost" size="sm" className="w-full justify-start text-success">
          <RefreshCw className="h-4 w-4 mr-2" />
          Reactivate User
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Reactivate User</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to reactivate <strong>{user.display_name || user.email}</strong>?
            <br />
            <br />
            This will restore their access to the system and they will be able to sign in again.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleReactivate}
            disabled={reactivateUser.isPending}
            className="bg-success text-success-foreground hover:bg-success/90"
          >
            {reactivateUser.isPending ? "Reactivating..." : "Reactivate User"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
